var USER_ACTIONS = {
    INIT_USER: 'INIT_USER',
    RESET_USER: 'RESET_USER',
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
};

export { USER_ACTIONS as U };
//# sourceMappingURL=bundle-D9MeorzH.js.map
